import { ColumnState, SortDirection } from 'ag-grid-community';
import { ColumnConfig, GridConfig } from './preference-api.types';

/**
 * Maps GridConfig returned by the backend API into ag-grid ColumnState[]
 */
export function mapApiToColumnState(gridConfig: GridConfig): ColumnState[] {
  if (!gridConfig.columns) {
    return [];
  }

  return gridConfig.columns.map((col): ColumnState => {
    const sorting = col.sorting;

    let parsedSortIndex: number | null = null;
    if (sorting?.sortIndex) {
      const parsed = Number(sorting?.sortIndex);
      parsedSortIndex = Number.isNaN(parsed) ? null : parsed;
    }

    return {
      colId: col.field,
      hide: !col.visible,
      width: col.width,
      sort: (sorting?.sortOrder || null) as SortDirection,
      sortIndex: parsedSortIndex,
    };
  });
}

/**
 * Maps ag-grid ColumnState[] into GridConfig required by the backend PUT API
 */
export function mapColumnStateToApi(
  gridName: string,
  states: ColumnState[]
): GridConfig {
  const columns: ColumnConfig[] = states.map((state): ColumnConfig => {
    const colConfig: ColumnConfig = {
      field: state.colId || '',
      visible: !state.hide,
    };

    if (state.width !== undefined && state.width !== null) {
      colConfig.width = state.width;
    }

    if (state.sort) {
      colConfig.sorting = {
        sortOrder: state.sort,
        sortIndex:
          state.sortIndex !== null && state.sortIndex !== undefined
            ? state.sortIndex.toString()
            : '0',
        isSortable: true,
      };
    }

    return colConfig;
  });

  return {
    gridName,
    columns,
  };
}
